import * as pdfjs from 'pdfjs-dist';

// Required for pdf preview
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).href;

export const previewPdf = async (pdfUrl: string) => {
  try {
    const pdf = await pdfjs.getDocument({ url: pdfUrl }).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 2 });
    const canvas = document.createElement('canvas');
    canvas.width = viewport.width;
    canvas.height = viewport.height;
    await page.render({
      canvas: null,
      canvasContext: canvas.getContext('2d')!,
      viewport,
    }).promise;
    return canvas.toDataURL();
  } catch (err) {
    console.error('PDF thumbnail error:', err);
    return null;
  }
};
